import API from '../utils/api';

export const createCategory = (category, cbFn) => {
    return API.post(`/admin/category/create`, category).then((response) => {
        if (response && response.status && response.status === 200) {
            cbFn(response.data.ResponseText);
        } else if (response && response.status != 200) {
            cbFn(response.data.ResponseText, true);
        }
    }).catch((error) => {
        cbFn('Unexpected Error', true)
    })
}

export const updatecategory = (category_id, category, cbFn) => {
    return API.post(`/admin/category/update/${category_id}`, category).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn(response.data.desc);
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        cbFn('Unexpected Error', true)
    })
}

export const updatesubcategory = (subcategory, cbFn) => {
    return API.post(`/category/services/update/sub/category`, subcategory).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn(response.data.desc);
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        cbFn('Unexpected Error', true)
    })
}

export const registersubcategory = (subcategory, cbFn) => {
    return API.post(`/common/sub-category/create`, subcategory).then((response) => {
        console.log("response -----------", response);
        if (response && response.status && response.status === 200) {
            cbFn(response.data.ResponseText);
        } else if (response && response.status != 200) {
            cbFn(response.data.ResponseText, true);
        }
    })
}


export const getcategorieslist = (countryid) => {
    return API.get(`/common/category/get?countryId=${countryid}`);
}

export const deletecategory = (catId, cbFn) => {
    
    return API.get(`/common/category/delete/${catId}`).then((response) => {
       
        if (response && response.status === 200) {
            cbFn(response.ResponseText);
        } else if (response && response.status !== 200) {
            cbFn(response.ResponseText, true);
        }
    }).catch((error) => {
        cbFn('Unexpected Error', true);
    })
}

export const deletesubcategory = (subcatId, cbFn) => {
    return API.post(`/category/services/delete/sub/category/${subcatId}`).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn(response.data.desc);
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        cbFn('Unexpected Error', true)
    })
}
